import { ClientGetDiscovery, ClientGetDiscoveryResponse } from "../../proto/ClientGetDiscovery_pb";
import store from "../../store";
import { addDiscoveryPages } from "../../store/discovery/actions";
import BaseHandler from "../BaseHandler";

export default class HandleClientGetDiscoveryResponse extends BaseHandler<ClientGetDiscoveryResponse, ClientGetDiscovery> {
  handle() {
    console.log("hello");
    const clientGetDiscoveryRequest = this.request?.toObject();
    const clientGetDiscoveryResponse = this.response.toObject();
    if (clientGetDiscoveryRequest !== undefined) {
      store.dispatch(
        addDiscoveryPages({
          [clientGetDiscoveryRequest.pageId]: clientGetDiscoveryResponse,
        })
      );
    }
  }
}
